import moduleConfig from './module-config';
import netsGenericError from './nets-generic-error';

export default angular
  .module('app.genericError', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsGenericError', netsGenericError);
